import { I18nText } from '@elderbyte/ngx-starter'
import { ProductionListPropertyResolveSpec } from './production-list-property-resolve-spec'
import { ValueFormatSpec } from '../columns/value-format-spec'

export class ProductionListPropertyDefinition {
  constructor(
    public id: string,
    public nameI18n: I18nText[],
    public resolveSpec: ProductionListPropertyResolveSpec,
    public formatSpec: ValueFormatSpec
  ) {}
}
